import JsSIP from 'jssip/JsSIP';
import Transport from 'jssip/Transport';

// Add browser userAgent to JsSIP

JsSIP.C.USER_AGENT += ' Browser - ' + navigator.userAgent;

// Override JsSIP Transport _reconnect to disable auto-reconnect

Transport.prototype._reconnect = () => {};

export default JsSIP;
